import { Availability } from 'src/generated/graphql';

function max(value: undefined | number) {
    if (value === undefined) {
        return undefined;
    }

    if (value > 0) {
        return value;
    }

    return undefined;
}

export const getMaxSizeAvailableProperties = (offices: {
    size?: number | null | undefined,
    available: Availability
}[]): number | undefined => (
    offices.reduce((acc, { size, available }) => {
        if (available === Availability.Available || available === Availability.Comingsoon) {
            return acc + (size || 0);
        }
        return acc;
    }, 0)
);

export const getMinSizeAvailableProperties = (offices: {
    size?: number | null | undefined,
    available: Availability
}[]): number | undefined => (
    offices.reduce((acc, { size, available }) => {
        if (available === Availability.Available || available === Availability.Comingsoon) {
            return acc < (size || 0) ? acc : (size || 0);
        }
        return acc;
    }, (offices.filter((o) => o.available === Availability.Available
        || o.available === Availability.Comingsoon)[0].size || 0))
);

export const getMinLeaseCost = (
    offices: {
        price?: number | null | undefined,
        size?: number | null | undefined;
    }[],
): number | undefined => (
    max(Math.min(...offices.map(({ price }) => price || 0)))
);
